import { render, staticRenderFns } from "./dictionaryMessage.vue?vue&type=template&id=30c97788&scoped=true&"
import script from "./dictionaryMessage.vue?vue&type=script&lang=js&"
export * from "./dictionaryMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c97788",
  null
  
)

export default component.exports